import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../lib/LanguageContext';
import translations from '../lib/translations';
import './Home.css';

function Home() {
  const { language } = useLanguage();
  const t = translations[language].home;
  const docs = translations[language].documents;

  return (
    <div className="home">
      {/* Hero */}
      <section className="hero">
        <p className="hero-badge">{t.heroBadge}</p>
        <h1 className="hero-title">{t.heroTitle}</h1>
        <p className="hero-body">{t.heroBody}</p>
        <p className="hero-meta">
          {t.heroMeta} &nbsp;&middot;&nbsp; MegaBliss LTD
        </p>
      </section>

      {/* Document cards */}
      <section className="docs-section">
        <h2 className="section-heading">{t.sectionHeading}</h2>
        <p className="section-sub">{t.sectionSub}</p>
        <div className="cards-grid">
          {docs.map((doc) => (
            <Link key={doc.to} to={doc.to} className="doc-card">
              <div className="doc-card-top">
                <span className="doc-icon" aria-hidden="true">
                  {doc.icon}
                </span>
                <span className="doc-badge">{doc.badge}</span>
              </div>
              <h3 className="doc-card-title">{doc.title}</h3>
              <p className="doc-card-desc">{doc.desc}</p>
              <span className="doc-card-cta">{t.readDoc} &rarr;</span>
            </Link>
          ))}
        </div>
      </section>

      {/* Contact */}
      <section className="contact-banner">
        <h2 className="contact-heading">{t.contactHeading}</h2>
        <p>
          {t.contactBody}{' '}
          <a href="mailto:admin@megablissworldwide.com">admin@megablissworldwide.com</a>.
        </p>
        <p className="contact-company">{t.contactCompany}</p>
      </section>
    </div>
  );
}

export default Home;
